module.exports = "mat-form-field span.description {\n  margin-bottom: 15px;\n  display: inline-block; }\n"